import { useEffect, useRef } from 'react'

// eslint-disable-next-line
export const useEffectOnce = (effect: () => any) => {
  const destroyFunc = useRef()
  const calledOnce = useRef(false)
  const renderAfterCalled = useRef(false)

  if (calledOnce.current) {
    renderAfterCalled.current = true
  }

  useEffect(() => {
    if (calledOnce.current) {
      return () => true;
    }

    calledOnce.current = true
    destroyFunc.current = effect()

    return () => {
      if (!renderAfterCalled.current) {
        return
      }

      // if (isArrowFunction(destroyFunc.current)) {
      //   destroyFunc.current();
      // }
    }
    // eslint-disable-next-line
  }, [])
}
